import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Home from "./pages/Home";
import ServicesSimple from "./pages/ServicesSimple";
import ReservationSimple from "./pages/ReservationSimple";
import Contact from "./pages/Contact";
import GiftCard from "./pages/GiftCard";
import GiftCardSuccess from "./pages/GiftCardSuccess";
import GiftCardCart from "./pages/GiftCardCart";
import SubscriptionsSimple from "./pages/SubscriptionsSimple";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";
import Admin from "./pages/Admin";
import Accueil from "./pages/Accueil";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import AnnouncementBanner from "./components/AnnouncementBanner";
import PromoBanner from "./components/PromoBanner";
import PWABanner from "./components/PWABanner";
import ScrollToTop from "./components/ScrollToTop";
import { Toaster } from "./components/ui/sonner";
import { CartProvider } from "./context/CartContext";

// Layout component to conditionally show Navbar/Footer
function Layout({ children }) {
  const location = useLocation();
  const isAdminPage = location.pathname === '/admin' || location.pathname === '/accueil';
  
  return (
    <>
      {!isAdminPage && <PromoBanner />}
      {!isAdminPage && <AnnouncementBanner />}
      {!isAdminPage && <Navbar />}
      <main className="flex-1">
        {children}
      </main>
      {!isAdminPage && <Footer />}
      {!isAdminPage && <PWABanner />}
    </>
  );
}

function App() {
  return (
    <div className="App min-h-screen flex flex-col">
      <BrowserRouter>
        <CartProvider>
          <ScrollToTop />
          <Layout>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/services" element={<ServicesSimple />} />
              <Route path="/reservation" element={<ReservationSimple />} />
              <Route path="/carte-cadeau" element={<GiftCard />} />
              <Route path="/carte-cadeau/panier" element={<GiftCardCart />} />
              <Route path="/carte-cadeau/success" element={<GiftCardSuccess />} />
              <Route path="/abonnements" element={<SubscriptionsSimple />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/blog/:postId" element={<BlogPost />} />
              <Route path="/admin" element={<Admin />} />
              <Route path="/accueil" element={<Accueil />} />
            </Routes>
          </Layout>
          <Toaster position="top-center" richColors />
        </CartProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
